import React from "react";
import { Container, Input, PageButton, PaginationContainer, TotalItems } from "./styles";
import { CaretDoubleLeft, CaretDoubleRight, CaretLeft, CaretRight } from "phosphor-react";
import InputDebounceAdapter from "../InputDebounceAdapter";

interface TimelineNavigatorProps {
  totalItems: number;
  currentItem: number;
  onNavigate: (itemIndex: number) => void;
  getClassName?: (itemIndex: number) => string; // Função para calcular classe individual
}

const TimelineNavigator: React.FC<TimelineNavigatorProps> = ({
  totalItems,
  currentItem,
  onNavigate,
  getClassName,
}) => {
  const visibleItems = 5;
  const halfRange = Math.floor(visibleItems / 2);

  const getVisibleItems = () => {
    let startItem = Math.max(0, currentItem - halfRange);
    let endItem = Math.min(totalItems - 1, startItem + visibleItems - 1);

    if (endItem - startItem + 1 < visibleItems) {
      startItem = Math.max(0, endItem - visibleItems + 1);
    }

    return Array.from({ length: endItem - startItem + 1 }, (_, i) => startItem + i);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = Number(e.target.value);
    if (isNaN(value) || value < 1 || value > totalItems) return; // Minimo ajustado para 1
    onNavigate(value - 1); // Subtrai 1 para ajustar o índice correto
  };

  return (
    <Container>
      <PaginationContainer>
        <PageButton onClick={() => onNavigate(0)} disabled={currentItem === 0}>
          <CaretDoubleLeft weight="bold" />
        </PageButton>
        <PageButton onClick={() => onNavigate(currentItem - 1)} disabled={currentItem === 0}>
          <CaretLeft weight="bold" />
        </PageButton>

        {getVisibleItems().map((item) => (
          <PageButton
            key={item}
            onClick={() => onNavigate(item)}
            active={item === currentItem}
            className={getClassName ? getClassName(item) : ""} // Aplica a classe individualmente
          >
            {item + 1}
          </PageButton>
        ))}

        <PageButton onClick={() => onNavigate(currentItem + 1)} disabled={currentItem === totalItems - 1}>
          <CaretRight weight="bold" />
        </PageButton>
        <PageButton onClick={() => onNavigate(totalItems - 1)} disabled={currentItem === totalItems - 1}>
          <CaretDoubleRight weight="bold" />
        </PageButton>

        <Input
          type="number"
          min={1} // Agora começa do 1, para alinhar com a exibição correta
          max={totalItems}
          value={currentItem + 1} // Exibe baseado em 1, mas ajustamos no onChange
          onChange={handleInputChange}
        />
        <TotalItems>de {totalItems} questões</TotalItems>
      </PaginationContainer>
    </Container>
  );
};

export default TimelineNavigator;
